/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Пустой ok-ответ
 */
export type EmptyResponse = object;

export interface RequestAccounts {
  /** Массив идентификаторов счетов */
  accounts?: string[];

  /** Идентификатор филиала */
  branchId: string;

  /** Идентификатор клиента АБС */
  clientId: string;

  /** Признак детализация по счету */
  withDetails: boolean;

  /** Признак */
  withBalance: boolean;
}

/**
 * Информация по счету
 */
export interface AccountDetails {
  /**
   * Идентификатор счета
   * @format uuid
   */
  id?: string;

  /** Наименование счета */
  name?: string;

  /** Номер счета */
  number?: string;

  /** Текущий остаток */
  currentBalance?: number;

  /** Доступный остаток */
  availableBalance?: number;

  /** Неиспользованный овердрафт */
  overdraft?: number;

  /** Валюта счета */
  currency?: string;

  /** Тип */
  type?: string;

  /** Код филиала */
  branchCode?: string;

  /** Наименование филиала */
  branchName?: string;

  /** Признак любимого счета */
  isFavouriteAccount?: boolean;

  /** Признак наличия блокировок */
  hasBlockDocuments?: boolean;

  /** Признак наличия картотеки */
  hasCardDocuments?: boolean;

  /** Информация о подопечном */
  wardInfo?: WardInfo;

  /** Статус счета */
  state?: string;
}

/**
 * Тело ответа на запрос списка счетов
 */
export interface AccountsResp {
  /** Список счетов */
  accounts?: AccountDetails[];

  /** Признак наличия номинальных счетов */
  hasNominalAccounts?: boolean;

  /** Признак наличия закрытых счетов */
  hasClosedAccounts?: boolean;

  /** Признак наличия блокировок */
  hasBlockedAccounts?: boolean;

  /** Признак наличия картотеки */
  hasCard2Accounts?: boolean;

  /** Информация о валютах счетов */
  currencyList?: string[];

  /** Информация об остатках на счетах в разрезе валют */
  currencyListWithCount?: Record<string, CurrencySum>;

  /** Информация о нумерации страниц */
  pagination?: Pagination;
}

/**
 * Суммы остатков в разрезе валют
 */
export interface CurrencySum {
  /** Сумма фактических остатков */
  balanceSum?: number;

  /** Сумма доступных остатков */
  availableBalanceSum?: number;
}

/**
 * Информация о нумерации страниц
 */
export interface Pagination {
  /**
   * Общее количество записей
   * @format int32
   */
  totalRecords?: number;

  /**
   * Количество открытых счетов
   * @format int32
   */
  opened?: number;

  /**
   * Количество закрытых счетов
   * @format int32
   */
  closed?: number;

  /**
   * Количество номинальных счетов
   * @format int32
   */
  nominal?: number;

  /**
   * Количество неноминальных счетов
   * @format int32
   */
  notNominal?: number;
}

/**
 * Информация о подопечном
 */
export interface WardInfo {
  /** Имя подопечного */
  wardFirstName?: string;

  /** Фамилия подопечного */
  wardLastName?: string;

  /** Отчество подопечного */
  wardMiddleName?: string;
}

/**
 * Тело ответа на запрос реквизитов счета
 */
export interface AccountRequisitesResp {
  /** Наименование филиала */
  bankName?: string;

  /** БИК банка */
  bankBic?: string;

  /** Номер счета */
  accountNumber?: string;

  /** Наименование клиента, которому принадлежит счет */
  accountClientName?: string;

  /** ИНН Клиента */
  accountClientInn?: string;

  /** КПП Клиента */
  accountClientKpp?: string;

  /** SWIFT банка */
  bankSwift?: string;

  /** Наименование Банка-корреспондента */
  bankCorrespondentName?: string;

  /** Счет в Банке-корреспонденте */
  bankCorrespondentAccount?: string;

  /** SWIFT Банка-корреспондента */
  bankCorrespondentSwift?: string;

  /** Информация о подопечном */
  wardInfo?: WardInfo;
}

/**
 * Блокировка по счету
 */
export interface AccountBlock {
  /**
   * Идентификатор блокировки
   * @format uuid
   */
  id?: string;

  /**
   * Дата и время начала блокировки
   * @format date-time
   */
  startDate?: string;

  /**
   * Дата и время окончания блокировки
   * @format date-time
   */
  endDate?: string;

  /** Тип блокировки */
  type?: string;

  /** Сумма блокировки */
  amount?: number;

  /** Сумма блокировки в национальной валюте */
  amountRub?: number;

  /** Список решений по блокировке счета */
  resolution?: AccountBlockResolution[];
}

/**
 * Решение по блокировке счета
 */
export interface AccountBlockResolution {
  /**
   * Идентификатор блокировки
   * @format uuid
   */
  id?: string;

  /** Признак действующее/недействующее постановление */
  active?: boolean;

  /**
   * Дата постановления
   * @format date-time
   */
  date?: string;

  /** Номер постановления */
  number?: string;

  /** Тип постановления */
  type?: string;

  /** Организация, установившая блокировку */
  organization?: Organization;
}

/**
 * Тело ответа на запрос блокировок по счету
 */
export interface AccountBlockResp {
  /** Список блокировок по счету */
  blocks?: AccountBlock[];
}

/**
 * Организация, установившая блокировку
 */
export interface Organization {
  /** Код органа, установившего блокировку */
  code?: string;

  /** Наименование органа, установившего блокировку */
  name?: string;
}

/**
 * Счет с проблемами
 */
export interface AccountWithIssues {
  /**
   * Идентификатор счета
   * @format uuid
   */
  id?: string;

  /** Наименование счета */
  name?: string;

  /** Номер счета */
  number?: string;

  /** Текущий остаток */
  currentBalance?: number;

  /** Доступный остаток */
  availableBalance?: number;

  /** Валюта счета */
  currency?: string;

  /** Признак наличия блокировок */
  hasBlockDocuments?: boolean;

  /** Признак наличия картотеки */
  hasCardDocuments?: boolean;
}

/**
 * Тело ответа на запрос списка счетов c проблемами
 */
export interface AccountsWithIssuesResp {
  /** Список счетов с проблемами */
  accounts?: AccountWithIssues[];
}

/**
 * Тело ответа на запрос получения настроек любимого счета
 */
export interface FavoriteAccountProperty {
  /** Имеются ли установленные избранные счета */
  hasFavorite?: boolean;

  /** Номер уже установленного любимого счета, если такой имеется */
  favoriteAccountNumber?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-finance
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-finance.ndbo.dev.rshbdev.ru
 * @contact https://gitlab.rshbdev.ru/rshbintech/crft/dboul/ndbo/backend/owb-ms-prd-finance <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/display/ndbouldev/Onboarding)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Клиентские ресты для счетов
     * @name SendAccountRequisitesEmail
     * @summary Отправка реквизитов по счету на E-mail
     * @request POST:/api/finance/v1/external/accounts/{id}/requisites/send
     */
    sendAccountRequisitesEmail: (
      id: string,
      query: { email: string },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/finance/v1/external/accounts/${id}/requisites/send`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Запросить информацию по счетам в ЦФТ
     *
     * @tags Клиентские ресты для счетов
     * @name SendAccountCftRequest
     * @summary Запросить информацию по счетам
     * @request POST:/api/finance/v1/external/accounts/cft/request
     */
    sendAccountCftRequest: (
      data: RequestAccounts,
      params: RequestParams = {}
    ) =>
      this.request<void, GenericError>({
        path: `/api/finance/v1/external/accounts/cft/request`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для счетов
     * @name GetAccountList
     * @summary Получение списка счетов
     * @request GET:/api/finance/v1/external/accounts
     */
    getAccountList: (
      query?: {
        searchText?: string;
        currency?: string;
        isNominal?: boolean;
        isOpen?: boolean;
        onMainPage?: boolean;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<AccountsResp, GenericError>({
        path: `/api/finance/v1/external/accounts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для счетов
     * @name GetAccountDetails
     * @summary Получение детальной информации по счету
     * @request GET:/api/finance/v1/external/accounts/{id}
     */
    getAccountDetails: (id: string, params: RequestParams = {}) =>
      this.request<AccountDetails, GenericError>({
        path: `/api/finance/v1/external/accounts/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для счетов
     * @name GetAccountRequisites
     * @summary Получение реквизитов счета
     * @request GET:/api/finance/v1/external/accounts/{id}/requisites
     */
    getAccountRequisites: (id: string, params: RequestParams = {}) =>
      this.request<AccountRequisitesResp, GenericError>({
        path: `/api/finance/v1/external/accounts/${id}/requisites`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для счетов
     * @name GetPrintedFormOfAccountDetails
     * @summary Получение печатной формы в формате PDF
     * @request GET:/api/finance/v1/external/accounts/{id}/requisites/load
     */
    getPrintedFormOfAccountDetails: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError>({
        path: `/api/finance/v1/external/accounts/${id}/requisites/load`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для счетов
     * @name GetAccountBlockList
     * @summary Получение блокировок по счету
     * @request GET:/api/finance/v1/external/accounts/{id}/block-info
     */
    getAccountBlockList: (id: string, params: RequestParams = {}) =>
      this.request<AccountBlockResp, GenericError>({
        path: `/api/finance/v1/external/accounts/${id}/block-info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для счетов
     * @name GetAccountListWithIssues
     * @summary Получение списка счетов c проблемами
     * @request GET:/api/finance/v1/external/accounts/issues
     */
    getAccountListWithIssues: (
      query: { includeBlock: boolean; includeCard2: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AccountsWithIssuesResp, GenericError>({
        path: `/api/finance/v1/external/accounts/issues`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для счетов
     * @name GetFavoriteAccountProperty
     * @summary Получение признака любимого счета
     * @request GET:/api/finance/v1/external/accounts/favorite-property
     */
    getFavoriteAccountProperty: (
      query: { currency: string },
      params: RequestParams = {}
    ) =>
      this.request<FavoriteAccountProperty, GenericError>({
        path: `/api/finance/v1/external/accounts/favorite-property`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
